const DEFAULT_FOOD_TYPES = ["Veg", "Non-Veg"];

export const normalizeFoodTypes = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    // Filter out any non-string values and ensure uniqueness
    return Array.from(
      new Set(value.filter((item): item is string => typeof item === "string"))
    );
  }

  if (typeof value === "string") {
    // JSON string from backend
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return Array.from(
          new Set(parsed.filter((item): item is string => typeof item === "string"))
        );
      }
    } catch {
      // comma-separated fallback
      return Array.from(
        new Set(
          value
            .split(",")
            .map((v) => v.trim())
            .filter(Boolean)
            .filter((item): item is string => typeof item === "string")
        )
      );
    }
  }

  return DEFAULT_FOOD_TYPES;
};

export const getFoodTypesOptions = (value: unknown): { value: string; label: string }[] => {
  const types = normalizeFoodTypes(value);
  return types.map((type: string) => ({
    value: type,
    label: type,
  }));
};